import { sendNotify } from '~/api'
import {
  ORDER_BEHAVIOR,
  ORDER_TYPE,
  RIGHTS_FEATURE,
  USER_LEVEL_KEY,
} from '~/api/interface'
import { USER_ADMIN } from '~/constants'
import { PageKey } from '~/constants/page'
import { useAddStorage } from '~/features/paymentDesk'

type MessageMap = { [key: string]: string[] }

type ActionInterceptOptions = {
  type?: number
}

const MESSAGE_MAP: () => MessageMap = () => {
  const { $t } = useNuxtApp()
  return {
    upgrade: [
      $t('yun-cun-chu-kong-jian-yi-man-qing-sheng-ji-quan-yi-hou-cao-zuo'),
      $t('fu-fei-sheng-ji'),
    ],
    buy: [
      $t(
        'yun-cun-chu-kong-jian-yi-man-qing-jia-gou-cun-chu-kong-jian-hou-cao-zuo'
      ),
      $t('jia-gou'),
    ],
    contact: [
      $t(
        'yun-cun-chu-kong-jian-yi-man-qing-lian-xi-guan-li-yuan-jia-gou-cun-chu-kong-jian-hou-cao-zuo'
      ),
      $t('tong-zhi-guan-li-yuan'),
    ],
  }
}

// 发送站内通知
const handleSendNotification = async () => {
  const { $t } = useNuxtApp()
  try {
    const response: any = await sendNotify()
    if (!response.error_code) {
      message.success($t('yi-tong-zhi-gei-guan-li-yuan'))
    }
  } catch (error) {
    console.error(error)
  }
}

export const useActionIntercept = (options?: ActionInterceptOptions) => {
  const userInfo: any = useUserInfo()
  const router = useRouter()
  const { $t } = useNuxtApp()

  const showMessage = (type: string, callback: (() => void) | undefined) => {
    message.warning(
      h('div', null, [
        MESSAGE_MAP()[type][0],
        h(
          'a',
          {
            class: 'text-primary cursor-pointer ml-[10px]',
            onClick: () => {
              message.destroy()
              callback?.()
            },
          },
          MESSAGE_MAP()[type][1]
        ),
      ])
    )
  }
  const noStorage = userInfo.value?.rights?.storage <= 0
  // 体验版
  if (
    (noStorage && userInfo.value?.rights_type === USER_LEVEL_KEY.TASTE) ||
    options?.type === HINT_MAP.UPGRADE_PERSON
  ) {
    showMessage('upgrade', () => {
      router.push({ name: PageKey.SUBSCRIBE })
    })
    return true
  }
  // 个人版
  if (
    (noStorage &&
      [USER_LEVEL_KEY.PERSONAL, USER_LEVEL_KEY.PERSONAL_LITE].includes(
        userInfo.value?.rights_type
      )) ||
    options?.type === HINT_MAP.BUY_STORAGE
  ) {
    showMessage('buy', () => {
      useAddStorage({
        title: $t('jia-gou-cun-chu-kong-jian'),
        user_info: userInfo.value,
        behavior: ORDER_BEHAVIOR.ADD_PURCHASE,
        feature_type: RIGHTS_FEATURE.storage,
        order_type: ORDER_TYPE.STORAGE,
      })
    })
    return true
  }

  // 企业版
  if (
    (noStorage &&
      [USER_LEVEL_KEY.ORG_STANDARD, USER_LEVEL_KEY.ORG_FLAGSHIP].includes(
        userInfo.value?.rights_type
      )) ||
    options?.type !== undefined
  ) {
    if (
      userInfo.value?.permission === USER_ADMIN.NORMAL ||
      options?.type === HINT_MAP.CONTACT_THE_ADMINISTRATOR
    ) {
      // 普通成员
      showMessage('contact', () => {
        // 发送站内通知
        handleSendNotification()
      })
    } else {
      showMessage('buy', () => {
        useAddStorage({
          title: $t('jia-gou-cun-chu-kong-jian'),
          user_info: userInfo.value,
          behavior: ORDER_BEHAVIOR.ADD_PURCHASE,
          feature_type: RIGHTS_FEATURE.storage,
          order_type: ORDER_TYPE.STORAGE,
        })
      })
    }
    return true
  }

  return false
}
